import PanelSection from "../intelligence/PanelSection";

const PendingModerationCard = ({ count, onOpenModeration }) => {
  return (
    <PanelSection eyebrow="Community" title="Pending moderation">
      <p className="admin-data-health-pending-count">{count ?? 0}</p>
      <p className="muted">
        Reports awaiting review (pending or needs review). Approve only after verifying details.
      </p>
      {onOpenModeration ? (
        <button type="button" className="midpoint-share-button" onClick={onOpenModeration}>
          Open moderation queue
        </button>
      ) : null}
    </PanelSection>
  );
};

export default PendingModerationCard;
